import React, { useState, Fragment } from 'react'
import '../Lock/css/lock.css'
import dayjs from 'dayjs'

import { swalInfo } from '../../common/components/Swaler'
import { store } from '../../store'
import checkBox from '../../assets/check-box.png'
import parcel from '../../assets/parcel.png'
import pin from '../../assets/pin.png'

import OpenQToolsBtn from '../QTools/OpenQToolsBtn'

const dayMapping = ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag']

const showCustomerDetails = (name, surname) => {
  if (!name || !surname) return

  const customerName = `${name} ${surname}`

  const customer = store.getState().collectionData.customers.find((c) => `${c.name} ${c.surname}` === customerName)
  if (!customer) return
  const title = `${customer.name} ${customer.surname}`
  const html = `<p>${customer.email || '-'}</p><p>${customer.phone || '-'}</p>`
  swalInfo(title, html)
}

type Props = {
  shipments: [
    {
      carrier: String,
      packageid: String,
      deliveryId?: String,
      carrierInternalOrderId?: String,
      packageType?: String,
      shipmentNumber: String,
      packageWeight: String,
      packageDimensions?: [Number],
      to_customer: { name: String, surname: String, company: String },
      lockName: String,
      created: String,
      isPickup?: Boolean,
      receiverCompany?: String,
      context: { identifiedPhone: String, identifiedCompany: String },
      checkoutDate: String,
      vendorName: String,
      deliveredToQlocxUnit: Boolean,
      bookedToQlocxUnit: Boolean,
      carrierImage: String,
    }
  ],
  openQtools: Function,
  openRawDeliveryData: Function,
}

const defaultProps = {
  shipments: [],
}

const DeliveryItem = ({ shipments, openQtools, openRawDeliveryData }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false)

  /* use first shipment that has a receiver, otherwise, use first element */
  const delivery = shipments.find((s) => s.to_customer && s.to_customer.name) || shipments[0]
  if (!delivery) return null

  const isPickup = delivery.is_pickup || delivery.isPickup

  const mainDate = dayjs(delivery.checkoutDate || delivery.created)
  const dateText = [`${dayMapping[mainDate.get('d')]}`, `${mainDate.format('D/M')}`]

  const totalWeight = Math.round(shipments.reduce((acc, s) => acc + Number(s.packageWeight || 0), 0))
  const highestWeight = Math.max(...shipments.map((s) => Number(s.packageWeight || 0)))
  const numReceivers = new Set(shipments.map((s) => s.to_customer && `${s.to_customer.name} ${s.to_customer.surname}`)).size
  const isUniqueReceiver = numReceivers === 1

  const toContainer = delivery.checkoutDate ? delivery.deliveredToQlocxUnit : delivery.bookedToQlocxUnit
  const toGateInsteadOfContainer = delivery.checkoutDate && delivery.bookedToQlocxUnit && !toContainer
  const couldBeBookedToContainerInsteadOfGate = delivery.checkoutDate && !delivery.bookedToQlocxUnit && totalWeight > 0 && totalWeight < 100 && highestWeight < 30

  const shouldShowContext = !delivery.receiverCompany && !(delivery.to_customer && delivery.to_customer.name) && delivery.context

  return (
    <div
      style={{
        background: 'white',
        borderRadius: 10,
        padding: 10,
        marginBottom: 10,
        boxShadow: '2px 2px 2px 2px lightgrey',
      }}
    >
      <div
        style={{
          display: 'flex',
          gridRow: 'auto',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <div
          style={{
            border: '2px solid #eee',
            borderRadius: 7,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 'bold',
            width: window.isMobile ? '30%' : 80,
            height: 80,
            textAlign: 'center',
            marginRight: 20,
          }}
        >
          <div>{dateText[0]}</div>
          <div>{dateText[1]}</div>
        </div>
        <div style={{ minWidth: window.isMobile ? '50%' : 100, height: 60 }}>{delivery.carrierImage ? <img style={{ height: '100%', width: 'auto' }} src={delivery.carrierImage} /> : 'LOGO'}</div>
        <div style={{ flex: '3 1 160px', minWidth: window.isMobile && '100%', paddingBottom: window.isMobile && 10 }} className="lock-label">
          <span style={{ fontWeight: '500' }}>{isPickup ? 'Upphämtning åt ' : 'Leverans från '} </span>
          <span>{delivery.vendorName || 'Okänd avsändare'}</span>
          <span style={{ fontWeight: '500' }}>{isPickup ? ' från ' : ' till '}</span>
          <span>
            {delivery.receiverCompany}
            {isUniqueReceiver
              && delivery.to_customer
              && (delivery.to_customer.name ? (
                <a className="event-item-link" style={{ cursor: 'pointer' }} onClick={() => showCustomerDetails(delivery.to_customer.name, delivery.to_customer.surname)}>
                  {!delivery.receiverCompany ? ` ${delivery.to_customer.name} ${delivery.to_customer.surname}` : ` (${delivery.to_customer.name} ${delivery.to_customer.surname})`}
                </a>
              ) : (
                delivery.to_customer.phone && ` inbjuden (${delivery.to_customer.phone})`
              ))}
            {shouldShowContext && ` Okänd (${delivery.context.identifiedCompany || 'Okänt företag'}, ${delivery.context.identifiedPhone || 'Mottagartelefonnummer saknas'})`}
            {!delivery.receiverCompany && !shouldShowContext && ` Okänt företag (${delivery.context.identifiedCompany || 'Okänt företag'})`}
          </span>
          <span>
            {numReceivers === 1 && delivery.to_customer && delivery.to_customer.company && !/\d/.test(delivery.to_customer.name) && delivery.to_customer.company && (
              <a className="event-item-link" style={{ cursor: 'pointer' }} onClick={() => showCustomerDetails(delivery.to_customer.name, delivery.to_customer.surname)}>{` (${delivery.to_customer.name})`}</a>
            )}
          </span>
        </div>
        <div style={{ flex: 1, display: 'flex', textAlign: 'center', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          {delivery.checkoutDate && (
            <Fragment>
              <img style={{ width: 28, marginBottom: 3 }} src={checkBox} alt="check-box" />
              <div style={{ fontSize: 12 }}>Utfördes</div>
              <div style={{ fontSize: 12 }}>{`${dayjs(delivery.checkoutDate).format('HH:mm')}`}</div>
            </Fragment>
          )}
        </div>
        <div style={{ flex: 1, display: 'flex', textAlign: 'center', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <img style={{ width: 28, marginBottom: 3 }} src={pin} alt="pin" />
          <div style={{ fontSize: 12 }}>{(toContainer ? 'Containern' : 'Grinden') + (toGateInsteadOfContainer ? ' (bokad till container)' : couldBeBookedToContainerInsteadOfGate ? ' (kunde ha bokats till container)' : '')}</div>
          <div style={{ fontSize: 12, minWidth: 180 }}>{delivery.lockName}</div>
        </div>
        <div style={{ flex: 1, display: 'flex', textAlign: 'center', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minWidth: window.isMobile && '100%' }}>
          <img style={{ width: 28, marginBottom: 3 }} src={parcel} alt="parcel" />
          <div style={{ fontSize: 12 }}>{`${shipments.length} kollin`}</div>
          <div style={{ fontSize: 12 }}>{`${totalWeight} kg`} </div>
        </div>
        <div style={{ flex: 1 }}>
          <p onClick={() => setIsExpanded(!isExpanded)} style={{ marginTop: 0 }} className="sub-title-text-container">
            {isExpanded ? 'Visa mindre' : 'Visa mer'}
          </p>
          <OpenQToolsBtn openQtools={openQtools} deliveries={shipments} />
        </div>
      </div>
      {isExpanded && (
        <div style={{ padding: '0 20px' }}>
          <hr style={{ borderTop: '1px solid #eee' }} />
          <div style={{ display: 'flex' }}>
            {!window.isMobile && <div style={{ minWidth: 94, height: 60 }} />}
            <div style={{ flex: 10 }}>
              <p>{`Inkommen: ${dayjs(delivery.created).format('D/M - YY HH:mm')}`}</p>
              {delivery.checkoutDate && (
                <p>
                  <span style={{ marginRight: 16 }}>Avslutad:</span>
                  <span>{dayjs(delivery.checkoutDate).format('D/M - YY HH:mm')}</span>
                </p>
              )}

              <p style={{ fontWeight: 'bold' }}>{`Kollin: ${shipments.length}, Totalvikt: ${totalWeight} kg, (Antal mottagare: ${numReceivers})`}</p>
              {shipments.map((s) => (
                <div style={{ marginBottom: window.isMobile && 10 }} key={s.packageid}>
                  <a className="event-item-link" style={{ cursor: 'pointer' }} onClick={() => openRawDeliveryData(s.carrierId, s.packageid)}>{`Kolli-ID: ${s.packageid}, `}</a>
                  <span>{`Sändningsnummer: ${s.carrierInternalOrderId || s.deliveryId || '-'}, `}</span>
                  <span>{`Vikt: ${s.packageWeight || '-'} kg, Dimensioner (meter): ${s.packageDimensions?.length > 0 ? `[${s.packageDimensions.join('x')}]` : '-'}, `}</span>
                  <span>{`Pakettyp: ${s.packageType || '-'}, `}</span>
                  <span>Mottagare: </span>
                  {s.to_customer && s.to_customer.name ? (
                    <a className="event-item-link" style={{ cursor: 'pointer' }} onClick={() => showCustomerDetails(s.to_customer.name, s.to_customer.surname)}>
                      {s.to_customer.name} {s.to_customer.surname}
                    </a>
                  ) : (
                    (s.to_customer && s.to_customer.phone) || 'Okänd'
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

DeliveryItem.defaultProps = defaultProps

export default DeliveryItem
